import { render } from "./TopbarView.vue?vue&type=template&id=1b4c444a"
import script from "./TopbarView.vue?vue&type=script&lang=js"
export * from "./TopbarView.vue?vue&type=script&lang=js"

import "./TopbarView.vue?vue&type=style&index=0&id=1b4c444a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__